import { atom } from 'recoil'
import { User } from '@griegconnect/krakentools-react-tenants'

export const userAtom = atom<User.Data | null>({
  key: 'userState',
  default: null,
})
